import React from "react";
import { Box } from "@mui/material";
import NonIconButton from "../../../../components/NonIconButton";
import { NormalText } from "../../../../components/TextParts";

export default function RegistrationSuccessful({ handleClose }) {
  return (
    <Box sx={{ py: "20px" }}>
      <Box sx={{ my: "20px" }}>
        <NormalText text="募集を受け付けました。ダッシュボードまたは募集一覧画面にて確認ください" />
      </Box>
      <NonIconButton title="閉じる" clickEvent={handleClose} />
    </Box>
  );
}